import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { UserProfileService } from '../services';

export const useGroupsQuery = () => {
  const queryKey = ['groups-key'];

  const queryFn = () => UserProfileService.getAllUserGroups();
  return useQuery({
    queryKey,
    queryFn,
    enabled: true,
  });
};

export const forceRefreshGroups = () => {
  queryClient.invalidateQueries(['groups-key']);
};
